

import { Field, Input } from "@fluentui/react-components";
import { useState } from "react";
import { isURLValid } from "../../../../utilities/SettingsHelper/SettingsHelper";

export interface IUrlInputProps {
    value: string
    label: string;
    onValueChange(value: string): void;
    onIsValidChange(isValid: boolean): void;
}

export const UrlInput = (props: IUrlInputProps) => {
    const { value, label, onValueChange, onIsValidChange } = props;

    const [validationState, setValidationState] = useState<"none" | "success" | "error">("none");
    const [validationMessage, setValidationMessage] = useState("");

    const isValueValid = (newValue: string): boolean => {
        if (!newValue || newValue.trim() === "") {
            return false;
        }

        return isURLValid(newValue);
    };

    const onValueChanged = (newValue: string) => {
        onValueChange(newValue);

        const isValueValidState = isValueValid(newValue);
        onIsValidChange(isValueValidState);

        setValidationState(isValueValidState ? "none" : "error");
        setValidationMessage(isValueValidState ? "" : "Please enter a valid URL.");
    };

    return (
        <Field required label={label} validationState={validationState} validationMessage={validationMessage}>
            <Input aria-label="url input" onChange={(_, data) => onValueChanged(data.value)} value={value} />
        </Field>
    );
};